import TraversalError from './traversalError'

export default class ResumeError extends TraversalError {
  constructor(message: string, traversalId: string | null = null) {
    super(message, traversalId)

    this.name = 'ResumeError'
  }
}
